'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ActionTypes$SUBSCRIB;

var _Immutable = require('Immutable');

var _ActionTypes = require('conversations-core/constants/ActionTypes');

var _ActionTypes2 = _interopRequireDefault(_ActionTypes);

var _ConversationStatusTypes = require('conversations-schema/constants/ConversationStatusTypes');

var _ConversationStatusTypes2 = _interopRequireDefault(_ConversationStatusTypes);

var _pubNubHelpers = require('conversations-core/utils/pubNubHelpers');

var _pollFunctionWithExponentialBackoff = require('conversations-lib/functions/pollFunctionWithExponentialBackoff');

var _pollFunctionWithExponentialBackoff2 = _interopRequireDefault(_pollFunctionWithExponentialBackoff);

var _ConversationsActions = require('conversations-core/actions/ConversationsActions');

var _clientSelectors = require('conversations-core/selectors/clientSelectors');

var _pubNubStatusSelectors = require('conversations-core/selectors/pubNubStatusSelectors');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var subscribeToChannels = function subscribeToChannels(client, listOfChannels) {
  client.subscribe({
    channels: listOfChannels,
    withPresence: true
  });
};

var unsubscribeFromChannels = function unsubscribeFromChannels(client, listOfChannels) {
  client.unsubscribe({
    channels: listOfChannels
  });
};

exports.default = (_ActionTypes$SUBSCRIB = {}, _defineProperty(_ActionTypes$SUBSCRIB, _ActionTypes2.default.SUBSCRIBE_TO_OPEN_CHANNELS, function (action, getState, dispatch, client) {
  var conversations = getState().entities.get('conversations', new _Immutable.Map());
  var openConversations = conversations.filter(function (conversation) {
    return conversation.status !== _ConversationStatusTypes2.default.ENDED;
  });
  if (openConversations.size > 0) {
    subscribeToChannels(client, openConversations.keySeq().toJS());
  }
}), _defineProperty(_ActionTypes$SUBSCRIB, _ActionTypes2.default.LEAVE_LOBBY, function (action, getState, dispatch, client) {
  var lobbyChannel = (0, _pubNubHelpers.getLobbyChannel)();
  unsubscribeFromChannels(client, [lobbyChannel]);
}), _defineProperty(_ActionTypes$SUBSCRIB, _ActionTypes2.default.LEAVE_CHANNEL, function (action, getState, dispatch, client) {
  var channel = action.payload.channel;

  unsubscribeFromChannels(client, [channel]);
}), _defineProperty(_ActionTypes$SUBSCRIB, _ActionTypes2.default.JOIN_LOBBY, function (action, getState, dispatch, client) {
  var lobbyChannel = (0, _pubNubHelpers.getLobbyChannel)();
  subscribeToChannels(client, [lobbyChannel]);
}), _defineProperty(_ActionTypes$SUBSCRIB, _ActionTypes2.default.OPEN_CONVERSATION_FOR_NEW_CHANNEL, function (action, getState, dispatch, client) {
  var newChannel = action.payload.channel;
  subscribeToChannels(client, [newChannel]);
}), _defineProperty(_ActionTypes$SUBSCRIB, _ActionTypes2.default.START_CHANNEL_SUBSCRIBE_POLL, function (action, getState, dispatch, client) {
  var _getChatConfig = (0, _clientSelectors.getChatConfig)(getState()),
      channels = _getChatConfig.channels;

  var fn = function fn() {
    var isResubscribing = (0, _pubNubStatusSelectors.getIsResubscribing)(getState());

    if (isResubscribing) {
      subscribeToChannels(client, channels);
      dispatch((0, _ConversationsActions.incrementPrivateChannelSubscribeCount)());
    }
  };

  (0, _pollFunctionWithExponentialBackoff2.default)({
    fn: fn,
    limit: 10
  });
}), _ActionTypes$SUBSCRIB);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-core/static-1.139/js/pubNubHandlers/subscribeHandlers.js
// module id = 503
// module chunks = 0